import React from "react";

export default function SubheaderSection() {
  return (
    <h2 className="text-darkText flex items-center justify-center text-2xl sm:text-3xl mb-8 mx-8 text-center">
      SERVING THE SEATTLE AREA SINCE 2016.
    </h2>
  );
}
